// Home - Shop the look (sections/home-shop-the-look.liquid)
// Prev/next and progress bars switch looks: the image crossfades and the card slides out and back in

const STL_OUT_MS = 260
const STL_IN_MS = 350
const STL_SHIFT_PX = 16

class HomeShopTheLook extends HTMLElement {
	connectedCallback() {
		this.images = [...this.querySelectorAll("[data-stl-image]")]
		this.texts = [...this.querySelectorAll("[data-stl-text]")]
		this.cards = [...this.querySelectorAll("[data-stl-card]")]
		this.bars = [...this.querySelectorAll("[data-stl-bar]")]
		this.current = this.querySelector("[data-stl-current]")
		this.index = 0
		this.busy = false
		this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

		if (this.cards.length < 2) return

		this.querySelector("[data-stl-prev]")?.addEventListener("click", () => this.go(this.index - 1))
		this.querySelector("[data-stl-next]")?.addEventListener("click", () => this.go(this.index + 1))
		this.bars.forEach((bar, i) => bar.addEventListener("click", () => this.go(i)))

		if (window.Shopify?.designMode) document.addEventListener("shopify:block:select", this.onBlockSelect)
	}

	disconnectedCallback() {
		document.removeEventListener("shopify:block:select", this.onBlockSelect)
	}

	go(target, instant = false) {
		let count = this.cards.length
		let next = (target + count) % count
		if (next === this.index || this.busy) return

		let direction = target > this.index ? 1 : -1
		let outgoing = this.cards[this.index]
		let incoming = this.cards[next]

		if (instant || this.reducedMotion) {
			this.swap(next)
			return
		}

		this.busy = true
		let out = outgoing.animate(
			[{ opacity: 1, transform: "none" }, { opacity: 0, transform: `translateX(${-STL_SHIFT_PX * direction}px)` }],
			{ duration: STL_OUT_MS, easing: "ease", fill: "forwards" }
		)

		out.finished.then(() => {
			this.swap(next)
			out.cancel()
			incoming.animate(
				[{ opacity: 0, transform: `translateX(${STL_SHIFT_PX * direction}px)` }, { opacity: 1, transform: "none" }],
				{ duration: STL_IN_MS, easing: "ease" }
			)
			this.busy = false
		})
	}

	swap(next) {
		let toggle = (list, i) => list.forEach((el, j) => el.classList.toggle("is-active", j === i))
		toggle(this.images, next)
		toggle(this.texts, next)
		toggle(this.cards, next)

		this.bars.forEach((bar, j) => {
			if (j === next) bar.setAttribute("aria-current", "true")
			else bar.removeAttribute("aria-current")
		})
		if (this.current) this.current.textContent = String(next + 1).padStart(2, "0")

		this.index = next
	}

	onBlockSelect = event => {
		let i = this.images.indexOf(event.target)
		if (i !== -1) this.go(i, true)
	}
}

if (!customElements.get("home-shop-the-look")) customElements.define("home-shop-the-look", HomeShopTheLook)
